/* global axios */
import ApiClient from './ApiClient';

class PipelineAutomationsAPI extends ApiClient {
  constructor() {
    super('pipeline_automations', { accountScoped: true });
  }

  getAvailableConfig() {
    return axios.get(`${this.url}/available_config`);
  }
}

export default new PipelineAutomationsAPI();
